module.exports = [{
  value: '',
  label: 'VALINTA_0',
  strikeMoreInformation_fi: '',
  automaticApproval: 'E',
  startDate: '',
  endDate: ''
}
]
